import { render, staticRenderFns } from "./ProfileTeacher.vue?vue&type=template&id=6b20cc94"
import script from "./ProfileTeacher.vue?vue&type=script&lang=js"
export * from "./ProfileTeacher.vue?vue&type=script&lang=js"
import style0 from "./ProfileTeacher.vue?vue&type=style&index=0&id=6b20cc94&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports